/* eslint-disable no-console */
import React, { PureComponent } from 'react';
import { defineMessages } from 'react-intl';
import {
  ActionsBarItemType,
  ActionsBarPosition,
} from 'bigbluebutton-html-plugin-sdk/dist/cjs/extensible-areas/actions-bar-item/enums';
import Styled from './styles';
import ActionsDropdown from './actions-dropdown/container';
import AudioCaptionsButtonContainer from '/imports/ui/components/audio/audio-graphql/audio-captions/button/component';
import AudioControlsContainer from '../audio/audio-graphql/audio-controls/component';
import JoinVideoOptionsContainer from '../video-provider/video-button/container';
import ScreenshareButtonContainer from './screenshare/container';
import SwapPresentationButton from './swap-presentation/component';
import Button from '/imports/ui/components/common/button/component';
import { getSettingsSingletonInstance } from '/imports/ui/services/settings';
import { ACTIONS, LAYOUT_TYPE, PANELS } from '../layout/enums';
import ReactionsButtonContainer from '/imports/ui/components/actions-bar/reactions-button/container';
import RaiseHandButtonContainer from '/imports/ui/components/actions-bar/raise-hand-button/container';
import Selector from '/imports/ui/components/common/selector/component';
import ToggleGroup from '/imports/ui/components/common/toggle-group/component';
import Separator from '/imports/ui/components/common/separator/component';
import CustomRemainingTimer from '../common/remaining-time/custom-remaining-time/Component';
import { startLiveSessionApi } from '/imports/ui/components/app/service';
import Auth from '/imports/ui/services/auth';

import deviceInfo from '/imports/utils/deviceInfo';

const intlMessages = defineMessages({
  actionsBarLabel: {
    id: 'app.actionsBar.label',
    description: 'Aria-label for ActionsBar Section',
  },
  toggleUserListLabel: {
    id: 'app.navBar.userListToggleBtnLabel',
    description: 'Toggle button label',
  },
  toggleUserListAria: {
    id: 'app.navBar.toggleUserList.ariaLabel',
    description: 'description of the lists inside the userlist',
  },
  titlePublic: {
    id: 'app.chat.titlePublic',
    description: 'title for public chat',
  },
  newMessages: {
    id: 'app.navBar.toggleUserList.newMessages',
    description: 'label for toggleUserList btn when showing red notification',
  },
});

class ActionsBar extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      isStartingLiveSession: false,
    };

    this.actionsBarRef = React.createRef();
    this.renderPluginsActionBarItems = this.renderPluginsActionBarItems.bind(this);
    this.handleStartLiveSession = this.handleStartLiveSession.bind(this);
  }

  async handleStartLiveSession() {
    const { isStartingLiveSession } = this.state;
    if (isStartingLiveSession) return;

    this.setState({ isStartingLiveSession: true });

    try {
      const payload = {
        internalMeetingID: Auth._meetingID,
        externalUserID: Auth._externUserID,
      };

      const response = await startLiveSessionApi(payload);

      if (response?.data?.success) {
        // Update localStorage to reflect the change
        localStorage.setItem('isPrepareLesson', 'false');
        // Reload the page to refresh the session state
        window.location.reload();
      } else {
        console.error('[ActionsBar] Failed to start live session:', response?.data?.error);
        this.setState({ isStartingLiveSession: false });
      }
    } catch (error) {
      console.error('[ActionsBar] Error starting live session:', error);
      this.setState({ isStartingLiveSession: false });
    }
  }

  renderPluginsActionBarItems(position) {
    const { actionBarItems } = this.props;
    return (
      <>
        {
          actionBarItems.filter((plugin) => plugin.position === position).map((plugin) => {
            let actionBarItemToReturn;
            switch (plugin.type) {
              case ActionsBarItemType.BUTTON:
                actionBarItemToReturn = (
                  <Button
                    key={`${plugin.type}-${plugin.id}`}
                    onClick={plugin.onClick}
                    hideLabel
                    color="primary"
                    icon={plugin.icon}
                    size="lg"
                    circle
                    label={plugin.tooltip}
                  />
                );
                break;
              case ActionsBarItemType.SEPARATOR:
                actionBarItemToReturn = (
                  <Separator
                    key={`${plugin.type}-${plugin.id}`}
                    actionsBar
                    icon={plugin.icon}
                  />
                );
                break;
              case ActionsBarItemType.SELECTOR:
                actionBarItemToReturn = (
                  <Selector
                    title={plugin.title}
                    options={plugin.options}
                    defaultOption={plugin.defaultOption}
                    onChange={plugin.onChange}
                    width={plugin.width}
                  />
                );
                break;
              case ActionsBarItemType.TOGGLE_GROUP:
                actionBarItemToReturn = (
                  <ToggleGroup
                    title={plugin.title}
                    options={plugin.options}
                    defaultOption={plugin.defaultOption}
                    onChange={plugin.onChange}
                    exclusive={plugin.exclusive}
                  />
                );
                break;
              default:
                actionBarItemToReturn = null;
                break;
            }
            return actionBarItemToReturn;
          })
        }
      </>
    );
  }

  renderReactionsButton() {
    return (
      <>
        <ReactionsButtonContainer actionsBarRef={this.actionsBarRef} />
      </>
    );
  }

  render() {
    const {
      amIPresenter,
      amIModerator,
      enableVideo,
      presentationIsOpen,
      intl,
      isSharingVideo,
      hasCameraAsContent,
      stopExternalVideoShare,
      isTimerActive,
      isTimerEnabled,
      isMeteorConnected,
      isPollingEnabled,
      allowExternalVideo,
      layoutContextDispatch,
      actionsBarStyle,
      setMeetingLayout,
      showPushLayout,
      setPushLayout,
      setPresentationFitToWidth,
      ariaHidden,
      showScreenshareQuickSwapButton,
      isReactionsButtonEnabled,
      isMobile,
      sidebarNavigation,
      sidebarContent,
      shortcuts: TOGGLE_USERLIST_AK, TOGGLE_CHAT_PUB_AK,
      hasUnreadMessages,
      idChatOpen,
      hasUnreadPublic,
      hasUnreadPrivate,
      isPrepareLesson,
    } = this.props;

    const Settings = getSettingsSingletonInstance();
    const { selectedLayout } = Settings.application;
    const shouldShowVideoButton = selectedLayout !== LAYOUT_TYPE.PRESENTATION_ONLY
      && selectedLayout !== LAYOUT_TYPE.PARTICIPANTS_AND_CHAT_ONLY;

    const { isPhone } = deviceInfo;

    const isExpanded = sidebarNavigation.isOpen;

    const hasNotification = hasUnreadMessages;
    //  const hasNotification = hasUnreadMessages || (hasUnreadNotes && !isPinned);
    let ariaLabel = intl.formatMessage(intlMessages.toggleUserListAria);
    ariaLabel += hasNotification ? (` ${intl.formatMessage(intlMessages.newMessages)}`) : '';
    const shouldShowNavBarToggleButton = selectedLayout !== LAYOUT_TYPE.CAMERAS_ONLY
      && selectedLayout !== LAYOUT_TYPE.PRESENTATION_ONLY
      && selectedLayout !== LAYOUT_TYPE.PARTICIPANTS_AND_CHAT_ONLY
      && selectedLayout !== LAYOUT_TYPE.MEDIA_ONLY;
    const CHAT_CONFIG = window.meetingClientSettings.public.chat;
    const PUBLIC_GROUP_CHAT_ID = CHAT_CONFIG.public_group_id;

    const isChatOpen = sidebarContent?.isOpen && idChatOpen === PUBLIC_GROUP_CHAT_ID;

    const handleToggleUserList = () => {
      if (sidebarNavigation.isOpen) {
        if (sidebarContent.isOpen) {
          layoutContextDispatch({
            type: ACTIONS.SET_SIDEBAR_CONTENT_IS_OPEN,
            value: false,
          });
          layoutContextDispatch({
            type: ACTIONS.SET_SIDEBAR_CONTENT_PANEL,
            value: PANELS.NONE,
          });
          layoutContextDispatch({
            type: ACTIONS.SET_ID_CHAT_OPEN,
            value: '',
          });
        }

        layoutContextDispatch({
          type: ACTIONS.SET_SIDEBAR_NAVIGATION_IS_OPEN,
          value: false,
        });
        layoutContextDispatch({
          type: ACTIONS.SET_SIDEBAR_NAVIGATION_PANEL,
          value: PANELS.NONE,
        });
      } else {
        // Close chat panel if open before opening user list
        const { sidebarContentIsOpen } = this.props;
        const isChatPanelOpen = sidebarContentIsOpen && idChatOpen === PUBLIC_GROUP_CHAT_ID;
        if (isChatPanelOpen) {
          layoutContextDispatch({ type: ACTIONS.SET_SIDEBAR_CONTENT_IS_OPEN, value: false });
          layoutContextDispatch({ type: ACTIONS.SET_SIDEBAR_CONTENT_PANEL, value: PANELS.NONE });
          layoutContextDispatch({ type: ACTIONS.SET_ID_CHAT_OPEN, value: '' });
        }
        layoutContextDispatch({
          type: ACTIONS.SET_SIDEBAR_NAVIGATION_IS_OPEN,
          value: true,
        });
        layoutContextDispatch({
          type: ACTIONS.SET_SIDEBAR_NAVIGATION_PANEL,
          value: PANELS.USERLIST,
        });
      }
    };

    const handleClickToggleChat = () => {
      const { sidebarContentIsOpen } = this.props;
      const chatIsOpen = sidebarContentIsOpen && PANELS.CHAT === 'chat';
      if (chatIsOpen) {
        if (idChatOpen === PUBLIC_GROUP_CHAT_ID) {
          layoutContextDispatch({
            type: ACTIONS.SET_SIDEBAR_CONTENT_IS_OPEN,
            value: false,
          });
          layoutContextDispatch({
            type: ACTIONS.SET_SIDEBAR_CONTENT_PANEL,
            value: PANELS.NONE,
          });
          layoutContextDispatch({ type: ACTIONS.SET_ID_CHAT_OPEN, value: '' });
        } else {
          if (sidebarNavigation.isOpen) {
            layoutContextDispatch({
              type: ACTIONS.SET_SIDEBAR_NAVIGATION_IS_OPEN,
              value: false,
            });
            layoutContextDispatch({
              type: ACTIONS.SET_SIDEBAR_NAVIGATION_PANEL,
              value: PANELS.NONE,
            });
          }
          layoutContextDispatch({ type: ACTIONS.SET_ID_CHAT_OPEN, value: PUBLIC_GROUP_CHAT_ID });
        }
      } else {
        if (sidebarNavigation.isOpen) {
          layoutContextDispatch({
            type: ACTIONS.SET_SIDEBAR_NAVIGATION_IS_OPEN,
            value: false,
          });
          layoutContextDispatch({
            type: ACTIONS.SET_SIDEBAR_NAVIGATION_PANEL,
            value: PANELS.NONE,
          });
        }
        layoutContextDispatch({ type: ACTIONS.SET_SIDEBAR_CONTENT_IS_OPEN, value: true });
        layoutContextDispatch({ type: ACTIONS.SET_SIDEBAR_CONTENT_PANEL, value: PANELS.CHAT });
        layoutContextDispatch({ type: ACTIONS.SET_ID_CHAT_OPEN, value: PUBLIC_GROUP_CHAT_ID });
      }
    };

    console.log('[ActionsBar RENDER]', { isPrepareLesson, amIPresenter, amIModerator });

    return (
      <Styled.ActionsBarWrapper
        id="ActionsBar"
        role="region"
        aria-label={intl.formatMessage(intlMessages.actionsBarLabel)}
        aria-hidden={ariaHidden}
        style={
          {
            position: 'absolute',
            top: actionsBarStyle.top,
            left: actionsBarStyle.left,
            height: actionsBarStyle.height,
            width: actionsBarStyle.width,
            padding: actionsBarStyle.padding,
          }
        }
      >
        <h2 className="sr-only">{intl.formatMessage(intlMessages.actionsBarLabel)}</h2>
        <Styled.ActionsBar
          ref={this.actionsBarRef}
          style={
            {
              height: actionsBarStyle.innerHeight,
            }
          }
        >
          <Styled.Left>
            {
              !isPrepareLesson && (
              <>
                {!isPhone && shouldShowNavBarToggleButton && (
                <Styled.NavbarToggleButton
                  tooltipplacement="right"
                  onClick={handleToggleUserList}
                    // color='none'
                  color={isExpanded ? 'primary' : 'default'}
                  size="lg"
                  circle
                  hideLabel
                  data-test={hasUnreadPrivate ? 'hasUnreadMessages' : 'toggleUserList'}
                  label={intl.formatMessage(intlMessages.toggleUserListLabel)}
                  tooltipLabel={intl.formatMessage(intlMessages.toggleUserListLabel)}
                  aria-label={ariaLabel}
                  icon="user"
                    // customIcon={
                    //   isExpanded
                    //     ? <SvgIcon iconName="sidebarLeft" />
                    //     : <SvgIcon iconName="sidebarRight" />
                    // }
                  aria-expanded={isExpanded}
                  accessKey={TOGGLE_USERLIST_AK}
                  hasNotification={hasUnreadPrivate}
                />
                )}
                {/* PUBLIC CHAT */}
                <Styled.NavbarToggleButton
                  tooltipplacement="right"
                  color={isChatOpen ? 'primary' : 'default'}
                  size="lg"
                  circle
                  hideLabel
                  data-test={hasUnreadPublic ? 'hasUnreadMessages' : 'toggleChat'}
                  label={intl.formatMessage(intlMessages.titlePublic)}
                  tooltipLabel={intl.formatMessage(intlMessages.titlePublic)}
                  aria-label={ariaLabel}
                  icon="chat"
                  aria-expanded={isExpanded}
                  accessKey={TOGGLE_CHAT_PUB_AK}
                  onClick={handleClickToggleChat}
                  hasNotification={hasUnreadPublic}
                />
              </>
              )
            }

            <ActionsDropdown {...{
              amIPresenter,
              amIModerator,
              isPollingEnabled,
              allowExternalVideo,
              intl,
              isSharingVideo,
              stopExternalVideoShare,
              isTimerActive,
              isTimerEnabled,
              isMeteorConnected,
              setMeetingLayout,
              setPushLayout,
              presentationIsOpen,
              showPushLayout,
              hasCameraAsContent,
              setPresentationFitToWidth,
              isPrepareLesson,
            }}
            />
          </Styled.Left>
          {
            !isPrepareLesson && (
              <Styled.Center>
                {this.renderPluginsActionBarItems(ActionsBarPosition.LEFT)}
                <AudioCaptionsButtonContainer />
                <AudioControlsContainer />
                {shouldShowVideoButton && enableVideo
                  ? (
                    <JoinVideoOptionsContainer />
                  )
                  : null}
                <ScreenshareButtonContainer
                  amIPresenter={amIPresenter}
                  isMeteorConnected={isMeteorConnected}
                />
                {
                  showScreenshareQuickSwapButton && <SwapPresentationButton />
                }
                {isReactionsButtonEnabled && this.renderReactionsButton()}
                <RaiseHandButtonContainer />
                {this.renderPluginsActionBarItems(ActionsBarPosition.RIGHT)}
              </Styled.Center>
            )
          }

          <Styled.Right>
            {/* <CustomRemainingTimer /> */}
            {!isMobile && !isPrepareLesson
              && <CustomRemainingTimer />}
            {/* <MeetingRemainingTime /> */}

            <Styled.Gap>
              {/* <SwapPresentationButton /> */}
              {/* {
                showScreenshareQuickSwapButton && <SwapPresentationButton />
              } */}
              {/* {shouldShowPresentationButton && shouldShowOptionsButton
                ? (
                  <PresentationOptionsContainer
                    presentationIsOpen={presentationIsOpen}
                    setPresentationIsOpen={setPresentationIsOpen}
                    layoutContextDispatch={layoutContextDispatch}
                    hasPresentation={isThereCurrentPresentation}
                    hasExternalVideo={isSharingVideo}
                    hasScreenshare={hasScreenshare}
                    hasPinnedSharedNotes={isSharedNotesPinned}
                    hasGenericContent={hasGenericContent}
                    hasCameraAsContent={hasCameraAsContent}
                  />
                )
                : null} */}
            </Styled.Gap>
          </Styled.Right>
        </Styled.ActionsBar>
      </Styled.ActionsBarWrapper>
    );
  }
}

export default ActionsBar;
